import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import Dialog from './../../../../UiComponents/Dialog';
import styles from './messageSequencer.module.scss';
import MessageItem from './MessageList';
import upArrow from './../../../../../globals/images/arrow_upward.svg';
import downArrow from './../../../../../globals/images/arrow_downward.svg';

import {
    isFirstOPtion,
    isLastOption,
    shiftOptionDown,
    shiftOptionUp
} from './utils';


class MessageSequencer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            options: props.options,
            selectedOption: null,
        };
    }

    moveOptionUp = (id) => {
        if (!id) { return null }
        const currentOption = this.state.options.find((option) => option.id === id);

        if (isFirstOPtion(currentOption)) { return null; }

        this.setState({
            options: shiftOptionUp(this.state.options, currentOption),
            moveupCount: !this.state.moveupCount ? 0 :
                this.state.moveupCount++
        })
    }

    moveOptionDown = (id) => {
        if (!id) return null;
        const { options } = this.state;
        const currentOption = options.find((option) => option.id === id);

        if (isLastOption(currentOption, options)) { return null; }

        this.setState({
            options: shiftOptionDown(options, currentOption),
            movedownCount: !this.state.movedownCount ? 0 : this.state.movedownCount++
        });
    }

    clearSelectedOPtion = () => {
        this.props.handleClose();
        this.setState({
            isOpen: false,
            selectedOption: undefined,
        });
    }

    updateData = () => {
        //updateing parent compoennt 
        this.props.updateBody(this.state.id, this.state.options);
        this.props.handleClose();
    }

    onOptionClick = (id) => {
        this.setState({
            selectedOption: id,
        });
    }

    getButton = () => (
        <div className={styles['button-contianer']}>
            <div className={styles['up-arrow']} onClick={() => {
                this.moveOptionUp(this.state.selectedOption)
            }}> <img src={upArrow} alt="" /> </div>
            <div className={styles['down-arrow']}
                onClick={() => {
                    this.moveOptionDown(this.state.selectedOption)
                }}
            >  <img src={downArrow} alt="downarrow" /></div>
        </div>);

    render() {
        const { options } = this.state;
        const getMessageList = () => {
            const newOtions = sortBy(options, (option) => { return option.index; });
            return newOtions.map((option, key) => {
                return <MessageItem
                    {...option} key={key}
                    selectedOption={this.state.selectedOption}
                    onClick={this.onOptionClick}
                />;
            });
        };

        return <Dialog
            title="Arrange the Options."
            overlayClassName={styles.dialog}
            containerClassName={styles['overlay-container']}
            onClose={this.handleClose}
            buttons={
                [{
                    text: "OK",
                    onClick: () => this.updateData(),
                    className: styles['ok-button']
                }, {
                    text: "Cancel",
                    onClick: () => this.clearSelectedOPtion(),
                    className: styles['cancel-button']
                }]
            } >

            <div className={styles['message-list']}>
                {getMessageList()}
            </div>
            {this.getButton()}
        </Dialog>;
    }
}

MessageSequencer.propTypes = {
    options: PropTypes.array,
    handleClose: PropTypes.func,
    updateBody: PropTypes.func,
    id: PropTypes.number,
};

MessageSequencer.defaultProps = {};

export default MessageSequencer;



// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageSequencer/MessageSequencer.js